export default __webpack_public_path__ + "static/media/icon-20-icn-no-connection.7085bb17.svg";